function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { ArrowDown } from '@suranceadmin/icons/native';
import TextInput from '../TextInput';
import { withTheme } from '../../core/theming';

const Dropdown = _ref => {
  let {
    value,
    placeholder,
    textInputAccessibility,
    theme: {
      colors
    },
    showsIcon = true,
    isSmallScreen = false,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({}, props, {
    accessible: false
  }), /*#__PURE__*/React.createElement(View, {
    pointerEvents: "none"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, textInputAccessibility, {
    value: value,
    isSmallScreen: isSmallScreen,
    placeholder: placeholder,
    icon: showsIcon && /*#__PURE__*/React.createElement(ArrowDown, {
      color: colors.icon.link,
      width: 16,
      height: 16
    })
  }))));
};

export default withTheme(Dropdown);
//# sourceMappingURL=index.js.map